import { type UploadFileFormDataFragment } from '../../../../api/fragments/UploadFileFormData';
import { type UploadFileWithPreviewFormDataFragment } from '../../../../api/fragments/UploadFileWithPreviewFormData';
import { type ModelConfiguratorSettings, BannerTextPosition } from '../../../../api/types';

export const FORM_NAME = 'modelConfiguratorForm';

export const LIST_URL = '/admin/configurators';

export type ModelConfiguratorFormValues = ModelConfiguratorSettings & {
    moduleId?: string;
    modelId?: string;
    banner?: File | UploadFileFormDataFragment;
    mobileBanner?: File | UploadFileFormDataFragment;
    descriptionImages: (File | UploadFileWithPreviewFormDataFragment)[];
};

export const defaultValues: ModelConfiguratorFormValues = {
    modelId: '',
    moduleId: '',
    isActive: false,
    externalUrl: '',
    configuratorTitle: {
        defaultValue: '',
        overrides: [],
    },
    pageTitle: {
        defaultValue: '',
        overrides: [],
    },
    pageSubtitle: {
        defaultValue: '',
        overrides: [],
    },
    pageDescription: {
        defaultValue: '',
        overrides: [],
    },
    bannerText: {
        defaultValue: '',
        overrides: [],
    },
    urlIdentifier: '',
    bannerTextPosition: BannerTextPosition.Left,
    priceDisclaimer: {
        defaultValue: [{ defaultValue: '', overrides: [] }],
        overrides: [],
    },
    descriptionImages: [],
};
